import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, clearToken, getToken, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ user: null, organisation: null, role: null, permissions: [] });
  const [status, setStatus] = useState("checking"); // checking | authed | guest

  const loadMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setState({ user: data.user, organisation: data.organisation, role: data.role, permissions: data.permissions || [] });
      setStatus("authed");
    } catch {
      clearToken();
      setStatus("guest");
    }
  };

  useEffect(() => {
    if (getToken()) loadMe();
    else setStatus("guest");
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      await loadMe();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearToken();
    setState({ user: null, organisation: null, role: null, permissions: [] });
    setStatus("guest");
    window.location.href = "/login";
  };

  const can = (perm) =>
    state.permissions.includes("*") ||
    state.permissions.includes(perm) ||
    state.permissions.includes(`${perm.split(".")[0]}.manage`);

  return (
    <AuthContext.Provider value={{ ...state, status, login, logout, can, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}
